import { Component, OnInit } from '@angular/core';
import { MarcacaoModel } from "../../models/marcacao.model";
import { SharedMarcacaoService } from "../../services/shared-marcacao.service";
import { PrintService } from "../../services/print.service";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ToastrService } from "ngx-toastr";
import { MedicoService } from "../../services/medico.service";
import { MedicoModel } from 'src/app/models/medico.model';

@Component({
  selector: 'app-exames',
  templateUrl: './exames.component.html',
  styleUrls: ['./exames.component.scss']
})
export class ExamesComponent implements OnInit {
  protected marcacaoAtual: MarcacaoModel;
  examesSelecionados: string[] = [];
  protected pedido_Exames_SafeHtml: SafeHtml | null = null;
  protected exameCopiado: string[] = [];
  protected medicos: MedicoModel[] = [];

  examesDisponiveis: string[] = [
    'Hemograma', 'Ferro sérico', 'CTLF', 'IST', 'TSH', 'T4 livre', 'T3',
    'Colesterol total e fracionado', 'Triglicerídeos', 'Glicemia de jejum',
    'Glicohemoglobina', 'Glicemia pós 75 g 2 h destrosol', 'AST', 'ALT', 'FA',
    'GGT', 'Ureia', 'Creatinina', 'Potássio', 'Sódio', 'Magnésio', 'Ácido úrico',
    'Vitamina D', 'Vitamina B12', 'Homocisteina', 'PC ultrassensível',
    'PCReativa quantitativa', 'AP/RNI', 'PTTa', 'Urina rotina',
    'Urocultura com eventual', 'Antibiograma', 'Razão albumina /Creatinina',
    'Exame parasitológico de fezes', 'Pesquisa de sangue oculto nas fezes'
  ];

  constructor(
    private sharedMarcacaoService: SharedMarcacaoService, 
    private printService: PrintService,
    private sanitizer: DomSanitizer, 
    private toastrService: ToastrService, 
    private medicoService: MedicoService
  ) {
    this.marcacaoAtual = new MarcacaoModel();
  }

  ngOnInit() {
    this.sharedMarcacaoService.marcacaoAtual.subscribe((res) => {
      this.marcacaoAtual = res ?? new MarcacaoModel();
      
      if (this.marcacaoAtual.pedido_Exames) {
        // Formata para a visão "travada" ficar um embaixo do outro
        const examesFormatadosHtml = this.marcacaoAtual.pedido_Exames
          .split(';')
          .map(e => e.trim())
          .filter(e => e)
          .join('<br>');
          
        this.pedido_Exames_SafeHtml = this.sanitizer.bypassSecurityTrustHtml(examesFormatadosHtml);
      }
      
      if (this.marcacaoAtual?.seq_Setor) {
        this.carregarMedicos(this.marcacaoAtual.seq_Setor, 'A');
      } else {
        if (this.marcacaoAtual.pedido_Exames) {
          this.examesSelecionados = this.marcacaoAtual.pedido_Exames.split(';').map(e => e.trim()).filter(e => e);
        } else if (!this.marcacaoAtual.isTravada) {
          this.examesSelecionados = [];
        } else {
          this.pedido_Exames_SafeHtml = null;
        }
      }
    });

    this.sharedMarcacaoService.exameCopiado.subscribe((exame: string[]) => {
      this.exameCopiado = exame;
    });
  }

  onExamesChange(val: string[]) {
    this.marcacaoAtual.pedido_Exames = val.join('; ');
  }

  imprimir() {
    const medico = this.marcacaoAtual.corpoClinico?.profissional;
    const numConselho = medico?.num_Conselho;
    const listaHtml = this.geraHtmlMedicos(this.medicos);

    // Formata os exames um abaixo do outro com um traço (bullet)
    let examesFormatados = '';
    if (this.marcacaoAtual.pedido_Exames) {
      examesFormatados = this.marcacaoAtual.pedido_Exames
        .split(';')
        .map(e => `<div style="margin-bottom: 4px;">- ${e.trim()}</div>`)
        .join('');
    }

    // Estrutura o HTML da observação (se houver)
    let observacaoHtml = '';
    if (this.marcacaoAtual.observacao_Exames) {
      // O replace transforma quebras de linha normais em <br> pro PDF/impressão
      const obsTexto = this.marcacaoAtual.observacao_Exames.replace(/\n/g, '<br>');
      observacaoHtml = `
        <div style="margin-top: 20px;">         
          <div style="margin-top: 5px;">${obsTexto}</div>
        </div>
      `;
    }

    // Monta o bloco que será enviado para a impressão
    const impressaoLayout = `
    ${listaHtml}
      <div style="padding-left: 240px; font-size: 12px; line-height: 1.4;">
        <div style="font-weight: bold; margin-bottom: 10px;">Exames Solicitados:</div>
        ${examesFormatados}
        ${observacaoHtml}
      </div>
    `;

    this.printService.printHtmlString(
      'Pedido de Exame', 
      this.marcacaoAtual.beneficiario?.nome_Beneficiario,
      impressaoLayout, 
      medico, 
      numConselho
    );
  }

  public copiarExame() {
    const REALIZADO = 6;
    const FINALIZADO = 7;

    if ((this.marcacaoAtual.status_Atendimento === FINALIZADO || this.marcacaoAtual.status_Atendimento === REALIZADO) && this.marcacaoAtual.pedido_Exames) {
      const examesToCopy = this.marcacaoAtual.pedido_Exames.split(';').map(e => e.trim()).filter(e => e.length > 0);

      this.sharedMarcacaoService.setExameCopiado(examesToCopy);
      this.toastrService.success('Lista de Exames copiada com sucesso!', 'Copiado');

    } else {
      this.toastrService.warning('Este botão só pode ser usado em atendimentos FINALIZADOS que contenham evolução.', 'Atenção');
    }
  }

  public colarExame() {
    const EM_ATENDIMENTO = 5;

    if (this.exameCopiado.length > 0 && this.marcacaoAtual.status_Atendimento === EM_ATENDIMENTO && !this.marcacaoAtual.isTravada) {
      const currentExams = this.examesSelecionados || [];
      const combinedExams = [...currentExams, ...this.exameCopiado];
      const uniqueExams = Array.from(new Set(combinedExams));

      this.examesSelecionados = uniqueExams;
      this.onExamesChange(this.examesSelecionados);
      this.sharedMarcacaoService.setExameCopiado([]);

      this.toastrService.success('Pedido de Exame anterior colado com sucesso!', 'Sucesso');

    } else if (this.marcacaoAtual.isTravada) {
      this.toastrService.warning('Não é possível colar: O atendimento está finalizado/travado.', 'Atenção');
    } else {
      this.toastrService.warning('O botão Colar só está habilitado para o atendimento com status igual à EM ATENDIMENTO e após copiar exames.', 'Atenção');
    }
  }

  carregarMedicos(seqSetor: number, status: string) {
    this.medicoService.getMedicos(seqSetor, status).subscribe({
      next: (res) => {
        if (!res.success) { return; }
        this.medicos = (res.data ?? []).flat();
      },
      error: (err) => {
        this.toastrService.error("Erro ao buscar médicos:", err);
      }
    });
  }

  geraHtmlMedicos(medicos: MedicoModel[]): string {
    if (!medicos || medicos.length === 0) return '';

    const itens = medicos.map(m => `
      <div style="margin-bottom: 6px;">
        <div style="font-weight: bold; font-size: 11px; color: #1a7f2e;">${m.nome ?? ''}</div>
        <div style="font-weight: bold; font-size: 11px; color: #1a7f2e;">${m.descricao_Especialidade ?? ''}</div>
      </div>
    `).join('');

    return `
    <div id="listaMedicos" style="position: fixed; top: 140px; left: 20px; width: 200px; height: auto;">
      ${itens}
    </div>`;
  }
}